import { dB64, eSha256 } from "./Encriptacion";

export function ValidarSesion(){
    const paginaActual = window.location.pathname;
    
    //VALIDAR SESIÓN DESDE EL LOGIN
    if(paginaActual == '/'){
        if(localStorage.getItem('r1') && localStorage.getItem('r2') && localStorage.getItem('r3') && localStorage.getItem('r4')){
            const r1 = dB64(localStorage.getItem('r1'));
            const r3 = localStorage.getItem('r3');
            const r4 = localStorage.getItem('r4');

            eSha256(`${r1}-${r4}`).then((hash) => {
                if(r3 == hash){
                    window.location.href = '/guias';
                }else{
                    localStorage.clear();
                }
            });
        }else{
            localStorage.clear();
        }
    }else{
        //VALIDAR SESIÓN DENTRO DE LA APLICACIÓN
        if(localStorage.getItem('r1') && localStorage.getItem('r2') && localStorage.getItem('r3') && localStorage.getItem('r4')){
            const r1 = dB64(localStorage.getItem('r1'));
            const r3 = localStorage.getItem('r3');
            const r4 = localStorage.getItem('r4');

            eSha256(`${r1}-${r4}`).then((hash) => {
                if(r3 != hash){
                    localStorage.clear();
                    window.location.href = '/';
                }
            });
        }else{
            localStorage.clear();
            window.location.href = '/';
        }
    }

}